<style src="@/assets/css/Home.css" scoped></style>
<style src="@/assets/css/common.css" scoped></style>
<style scoped>
.imgSet {
	width:30%;
	margin-top:30px;
	margin-bottom:30px;
}
.query-input-title {
	width: 90%;
	text-align: left;
	margin: auto;
}
.input_box{
	width: 97%;
}
.radioLeft {
	text-align: left;
}
.link_decoration{
	text-decoration: underline;
	text-align: left;
	color: #000080;
	cursor: pointer;
}
.radio-group-full-width >>>.v-input__control {
	width: 200%
}
.hide{
	display: none;
}
.myDIV:hover + .hide {
	display: inline;
	border-radius: 10px;
	padding: 5px; 
	width: 500px;
	background-color: #f3f8e9;
	color: black;
	position:absolute;
	font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L", "Helvetica Neue", Helvetica, Arial, sans-serif;
	z-index: 5;
	padding: 20px;
	border-style: solid;
	border-color: black;
	border-width: 1px;
	text-align: left;
	font-weight: normal;
}
</style>
<template>
	<div>
		<div class="header-text">
			<img class="imgSet" src="Tool1.png"/>
		</div>
		<b-container>
			<!-- First section: Mutation Information -->
			<b-row>
				<div class="sec_header"> 
					Mutation Information
					<span class="myDIV"><img src="question-mark.png" width=20/></span>
					<div class="hide">
						Mutation Annotation Format (MAF) is accepted. Please include header line in your input.
						<br>
						<br>
						Ten columns are required:
						<ul>
							<li>Chromosome</li>
							<li>Start_Position</li>
							<li>Reference_Allele</li>
							<li>Tumor_Seq_Allele2</li>
							<li>Variant_Classification</li>
							<li>ENSP</li>
							<li>Transcript_ID</li>
							<li>Gene</li>
							<li>Protein_position</li>
							<li>Tumor_Sample_Barcode</li>
						</ul>
						Other columns can also be present in the MAF file but they will not be used.
					</div>
				</div>
			</b-row>
			<b-row>
				<b-col cols="3">
					<div class="query-input-title">
						Input mutations: 
					</div>
					<div class="query-input-title">
						<label class="link_decoration" @click="loadExampleMutations">
							<u>Example</u>
						</label>
					</div>
				</b-col>
				<b-col cols="9">
					<b-form-textarea rows="8" v-model="mutation_textbox_input" class="input_box"></b-form-textarea>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="3">
					<div class="query-input-title">
						Or upload a file:
						<div class="link_decoration"><a href="/example/mutations.maf" download>Download example file</a>
						</div>
					</div>
				</b-col>
				<b-col cols="9">
					<b-input-group class="input_box">
					<b-form-file placeholder="No file chosen" @click="uploadDataset()" v-model="mutation_file_to_upload">Browse</b-form-file>
					</b-input-group>
				</b-col>
			</b-row>
		</b-container>
		<br>
		<br>
		<b-container>
			<!-- Second section: Expressed Genes -->
			<b-row>
				<div class="sec_header"> 
					[OPTIONAL] Expressed Genes
					<span class="myDIV"><img src="question-mark.png" width=20/></span>
					<div class="hide">
						Please provide a complete list of expressed genes in the context where your input mutations occur, with one ID per line. Gene name, Ensembl gene ID, Ensembl transcript ID, Ensembl protein ID, and UniProt ID are accepted. If this information is unavailable, you may leave this section blank. In such cases, NetFlow3D will assume all genes are expressed.
					</div>
				</div>
			</b-row>
			<b-row>
				<b-col cols="3">
					<div class="query-input-title"> Input expressed genes: 
					</div>
					<div class="query-input-title">
						<label class="link_decoration" @click="loadExampleGenes">
							<u>Example</u>
						</label>
					</div>
				</b-col>
				<b-col cols="9">
					<b-form-textarea rows="8" v-model="gene_textbox_input"></b-form-textarea>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="3">
					<div class="query-input-title"> Or upload file: 
						<div class="link_decoration"> <a href="/example/expressed_genes.txt" download>Download example file</a>
						</div>
					</div>
				</b-col>
				<b-col cols="9">
					<b-input-group>
					<b-form-file placeholder="No file chosen" @click="uploadDataset()" v-model="gene_file_to_upload">Browse</b-form-file>
					</b-input-group>
				</b-col>
			</b-row>
		</b-container>
		<br>
		<br>
		<b-container>
			<!-- Third section: Interactome -->
			<b-row>
				<div class="sec_header"> 
					[OPTIONAL] Existing Protein-Protein Interactions
					<span class="myDIV"><img src="question-mark.png" width=20/></span>
					<div class="hide">
						If this section is left blank (recommended), NetFlow3D will default to utilizing the high-quality binary interactome of Homo sapiens curated by HINT (http://hint.yulab.org/). Alternatively, if you wish to use customized data, please provide the complete interactome relevant to your context. Each interaction should be listed on a separate line, with interacting proteins separated by a tab. UniProt IDs and Ensembl gene/transcript/protein IDs are supported. 
					</div>
				</div>
			</b-row>
			<b-row>
				<b-col cols="3">
					<div class="query-input-title">
						Input interactome: 
					</div>
					<div class="query-input-title">
						<label class="link_decoration" @click="loadExampleInteractome">
							<u>Example</u>
						</label>
					</div>
				</b-col>
				<b-col cols="9">
					<b-form-textarea rows="8" v-model="interaction_textbox_input"></b-form-textarea>
				</b-col>
			</b-row>
			<br>
			<b-row>
				<b-col cols="3">
					<div class="query-input-title"> Or upload file: 
						<div class="link_decoration"> <a href="/example/interactome.txt" download>Download example file</a>
						</div>
					</div>
				</b-col>
				<b-col cols="9">
					<b-input-group>
					<b-form-file placeholder="No file chosen" @click="uploadDataset()" v-model="ppi_file_to_upload">Browse</b-form-file>
					</b-input-group>
				</b-col>
			</b-row>
		</b-container>
		
		<!-- Job information -->
		<!-- <div class="quick-query"> -->
			<!-- <div class="submission-input"> -->
				<!-- <b-row class="mb-2"> -->
				<!-- <div class="query-input-title"> Job Information: </div> -->
				<!-- </b-row> -->
				
				<!-- <b-row class="mb-2"> -->
					<!-- <b-col cols="4"> -->
						<!-- <div class="query-input-title"> Name for this job (optional): </div> -->
					<!-- </b-col> -->
					<!-- <b-col cols="8"> -->
						<!-- <b-form-textarea v-model="submitted_job_name"></b-form-textarea> -->
					<!-- </b-col> -->
				<!-- </b-row> -->
				<!-- <b-row class="mb-2"> -->
					<!-- <b-col cols="4"> -->
						<!-- <div class="query-input-title"> Email address (optional): -->
						<!-- <a href="#" data-toggle="tooltip" title="We will send you the result link once the analysis is complete."><img src="question-mark.png" width=20></a> -->
						<!-- </div> -->
					<!-- </b-col> -->
					<!--  <b-col cols="8"> -->
						<!-- <b-form-textarea v-model="submitted_job_email"></b-form-textarea> -->
					<!-- </b-col> -->
				<!-- </b-row> -->
			<!-- </div> -->
		<!-- </div> -->
		<!-- <div class="quick-query"> -->
			<!-- <div class="submission-input"> -->
				
					<!-- <div  v-for="item in advanced_options" :key="item"> -->
					<!-- <br> -->
					<!-- <b-row> -->
					<!-- <b-col cols="4"> -->
					<!-- <div class="query-option-title"> -->
					<!-- {{item.name}} -->
					<!-- </div> -->
					<!-- </b-col> -->
					<!-- <b-col cols="8"> -->
						<!-- <div class="radioLeft"> -->
						<!-- <b-form-radio-group> -->
							<!-- <b-row> -->
							<!-- <b-col cols="4" v-for="o in item.options" :key="o"> -->
							<!-- <b-form-radio v-model="selected" :value="o">{{o}}</b-form-radio> -->
							<!-- </b-col> -->
							<!-- </b-row> -->
						<!-- </b-form-radio-group> -->
						<!-- </div> -->
					<!-- </b-col> -->
					<!-- </b-row> -->

					<!-- </div> -->
			<!-- </div> -->
		<!-- </div> -->
		<br>
		<br>
		<label class="submit-button" style="margin-bottom:100px;" @click="sendQuery()">Run ></label>

	</div>
</template>

<script>
import axios from "axios";
export default {
	components: {
	},
	data() {
		// This is where you declare global reactive variables
		return {
			model_options: [{"text":"Low", "value":"low"}, {"text":"High", "value":"high"}],
			selected_model:"low",
			mutation_textbox_input:"",
			gene_textbox_input:"",
			interaction_textbox_input:"",
			ppi_file_to_upload:null,
			gene_file_to_upload:null,
			mutation_file_to_upload:null,
			hover: false,
			submitted_job_name:"",
			submitted_job_email:"",
		};
	},
	created() {
		//localStorage.clear();
	},
	methods: {
		loadExampleFile(path, targetField) {
		fetch(path)
			.then(response => {
				if (!response.ok) {
					throw new Error(`Failed to load ${path}`);
				}
				return response.text();
			})
			.then(text => {
				this[targetField] = text;
			})
			.catch(error => {
				console.error(error);
			});
		},

		loadExampleMutations() {
			this.loadExampleFile("/example/mutations.maf", "mutation_textbox_input");
		},

		loadExampleGenes() {
			this.loadExampleFile("/example/expressed_genes.txt", "gene_textbox_input");
		},

		loadExampleInteractome() {
			this.loadExampleFile("/example/interactome.txt", "interaction_textbox_input");
		},
			readFileAsText(file){
		return new Promise(function(resolve,reject){
		let fr = new FileReader();

		fr.onload = function(){
			resolve(fr.result);
		};

		fr.onerror = function(){
			reject(fr);
		};

		fr.readAsText(file);
		});
		},
		
		sendQuery() {
			console.log(axios);
			//fetch(this.mutation_file_to_upload).then(response => response.text()).then((text) => console.log(text));
			let readers = [];
			if (this.mutation_file_to_upload == null)
				readers.push(this.mutation_textbox_input);
			else
				readers.push(this.readFileAsText(this.mutation_file_to_upload));
			if (this.gene_file_to_upload == null)
				readers.push(this.gene_textbox_input);
			else
				readers.push(this.readFileAsText(this.gene_file_to_upload));
			if (this.ppi_file_to_upload == null)
				readers.push(this.interaction_textbox_input);
			else
				readers.push(this.readFileAsText(this.ppi_file_to_upload));
				
			Promise.all(readers).then((values) => {
				var mut, gene, ppi;
				[mut, gene, ppi] = values;
				if (mut.trim() == "") {
					console.log("Warning message");
				}
				else {
					let d = {"jobname":this.submitted_job_name, "jobemail":this.submitted_job_email, "mutation": mut, "gene": gene, "ppi": ppi, "resolution":this.selected_model};
					axios.post("http://netflow3dapi.yulab.org/submit_job", d)
					.then((response)=> {
						let d = response.data;
						
						this.$router.push({
							name: "results",
							params: {
								"jobtoken": d["token"]
							}
							});
					}); 
				}
			});
			
			//console.log(headers);
		},
	},
};
</script>

<!-- style sheet, not updated -->
<style scoped>
.small {
	max-width: 600px;
	margin: 150px auto;
}
.text-description-title {
	font-family: fantasy;
	font-size: larger;
}

.text-description-content {
	text-align: left;
}

.align-left {
	text-align: left;
}
.query-form-title {
	background-color: #eeeeee;
	text-align: center;
	padding-top: 5px;
	padding-right: 5px;
	padding-bottom: 5px;
	padding-left: 10px;
	font-weight: bold;
	
}
.query-option-title {
	text-align: left;
}

.quick-query {
  border-radius: 25px;
  border: 1px solid #000000;
	padding-top: 20px;
	padding-right: 50px;
	padding-bottom: 20px;
	padding-left: 50px;
	margin: 20px auto;
}
.advance-options-form {
  border: 1px solid #000000;
	padding-top: 10px;
	padding-right: 10px;
	padding-bottom: 10px;
	padding-left: 10px;
}

</style>
